import { ComponentPropsWithoutRef } from 'react';

import { cn } from '@components/primitives';

import { CardSection } from './CardSection';

import css from './styles.module.css';

type CardProps = ComponentPropsWithoutRef<'div'>;

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div className={cn(css.card, className)} {...props}>
      {children}
    </div>
  );
}

Card.Section = CardSection;
